import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavIconChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20.047 14.756 5.805.516a1.76 1.76 0 0 0-2.487 0l-1.66 1.66a1.76 1.76 0 0 0-.004 2.484L12.941 16 1.654 27.34a1.76 1.76 0 0 0 .003 2.484l1.661 1.66c.687.688 1.8.688 2.487 0l14.242-14.24c.686-.687.686-1.8 0-2.488" })
});
export default SvgNavIconChevronRight;
